import React from 'react';

import { CardList } from '../InvoiceCardList/InvoiceCardList.styled';

import { UnappliedPaymentCardListItem } from './UnappliedPaymentCardListItem';
import { Payment } from '../../types/payment';

export const UnappliedPaymentCardList = ({ payments }: { payments: Payment[] }) => {
  const cards = payments.map(payment => (
    <UnappliedPaymentCardListItem key={payment.id} payment={payment} />
  ));

  return <CardList>{cards}</CardList>;
};
